import _ from "lodash";
import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { GoogleLogin } from "react-google-login";

import { socialAuthenticateAccount } from "../../../authentication";

import styled from "styled-components";
const CustomGoogleButton = styled.button`
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: transparent;
  --blue: #007bff;
  --indigo: #6610f2;
  --purple: #6f42c1;
  --pink: #e83e8c;
  --red: #dc3545;
  --orange: #fd7e14;
  --yellow: #ffc107;
  --green: #28a745;
  --teal: #20c997;
  --cyan: #17a2b8;
  --white: #fff;
  --gray: #6c757d;
  --gray-dark: #343a40;
  --primary: #007bff;
  --secondary: #6c757d;
  --success: #28a745;
  --info: #17a2b8;
  --warning: #ffc107;
  --danger: #dc3545;
  --light: #f8f9fa;
  --dark: #343a40;
  --breakpoint-xs: 0;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif,
    "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas,
    "Liberation Mono", "Courier New", monospace;
  box-sizing: border-box;
  margin: 0;
  font-family: inherit;
  overflow: visible;
  text-transform: none;
  -webkit-appearance: button;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  color: #fff;
  display: block;
  width: 100%;
  border-radius: 0 !important;
  font-size: 18px !important;
  // background: rgb(37, 37, 37) !important;
  // border: 1px solid rgb(37, 37, 37) !important;
  cursor: pointer;

  // width: 100%;
  background: #de815c;
  // border-radius: 250.251px;
  // font-size: 1.5em;
  // font-family: Secular One;
  // color: #ffffff;
  // align-items: center;
  // text-align: center;
  // letter-spacing: 0.05em;
  // padding: 16px;
  // margin-top: 16px;
  // :focus {
  //   outline: none;
  //   box-shadow: 0px 0px 2px #0066ff;
  // }
`;
const GoogleLoginButton = styled(GoogleLogin)`
  width: 100%;
  justify-content: center;
  margin-top: 8px;
  border-radius: 250.251px;
`;
const GoogleLogo = styled.img`
  height: 25px;
  width: 25px;
  margin-right: 8px;
  vertical-align: bottom;
`;

const GoogleSocialAuthButton = (props) => {
  const handleResponseGoogle = (response) => {
    if (!_.get(response, "error")) {
      const values = {
        provider: "google-oauth2",
        code: _.get(response, "code"),
        redirect_uri: "postmessage",
      };
      props.socialAuthenticateAccount({ values });
    }
  };

  return (
    <GoogleLoginButton
      clientId={process.env.REACT_APP_GOOGLE_OAUTH_CLIEND_ID}
      buttonText="Continue with Google Account"
      onSuccess={handleResponseGoogle}
      onFailure={handleResponseGoogle}
      cookiePolicy={"single_host_origin"}
      responseType="code"
      render={(renderProps) => (
        <CustomGoogleButton
          onClick={renderProps.onClick}
          disabled={renderProps.disabled}
        >
          <GoogleLogo
            src={process.env.PUBLIC_URL + "/assets/images/google-logo.png"}
          />
          Continue with Google Account
        </CustomGoogleButton>
      )}
    />
  );
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      socialAuthenticateAccount,
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GoogleSocialAuthButton);
